const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const SystemItemAdd = () => import(/* webpackChunkName: "item" */ '@/modules/item/system/view/add.vue');
const SystemItemEdit = () => import(/* webpackChunkName: "item" */ '@/modules/item/system/view/edit.vue');
const SystemItemList = () => import(/* webpackChunkName: "item" */ '@/modules/item/system/view/index.vue');
const SystemItemLink = () => import(/* webpackChunkName: "item" */ '@/modules/item/system/view/link.vue');
const SystemItemTranslate = () => import(/* webpackChunkName: "item" */ '@/modules/item/system/view/translate.vue');
const AppItemSettingAdd = () => import(/* webpackChunkName: "item" */ '@/modules/item/app/setting/view/add.vue');
const AppItemSettingEdit = () => import(/* webpackChunkName: "item" */ '@/modules/item/app/setting/view/edit.vue');
const AppItemSetting = () => import(/* webpackChunkName: "item" */ '@/modules/item/app/setting/view/index.vue');

export const ROUTE_NAME_ITEM = {
    SYSTEM: {
        INDEX: 'SystemItemList',
        ADD: 'SystemItemAdd',
        EDIT: 'SystemItemEdit',
        LINK: 'SystemItemLink',
        TRANSLATE: 'SystemItemTranslate'
    },
    APP_SETTING: {
        INDEX: 'AppItemSettingList',
        ADD: 'AppItemSettingAdd',
        EDIT: 'AppItemSettingEdit'
    }
} as const;

export default [
    {
        path: '/system/item',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: '',
                name: ROUTE_NAME_ITEM.SYSTEM.INDEX,
                component: SystemItemList,
                meta: { requiresAuth: true }
            },
            {
                path: 'add',
                name: ROUTE_NAME_ITEM.SYSTEM.ADD,
                component: SystemItemAdd,
                meta: { requiresAuth: true }
            },
            {
                path: ':itemId/edit',
                name: ROUTE_NAME_ITEM.SYSTEM.EDIT,
                component: SystemItemEdit,
                meta: { requiresAuth: true }
            },
            {
                path: ':itemId/link',
                name: ROUTE_NAME_ITEM.SYSTEM.LINK,
                component: SystemItemLink,
                meta: { requiresAuth: true }
            },
            {
                path: ':itemId/translate',
                name: ROUTE_NAME_ITEM.SYSTEM.TRANSLATE,
                component: SystemItemTranslate,
                meta: { requiresAuth: true }
            }
        ]
    },
    {
        path: '/app/:appId/item/setting',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: '',
                name: ROUTE_NAME_ITEM.APP_SETTING.INDEX,
                component: AppItemSetting,
                meta: { requiresAuth: true }
            },
            {
                path: 'add',
                name: ROUTE_NAME_ITEM.APP_SETTING.ADD,
                component: AppItemSettingAdd,
                meta: { requiresAuth: true }
            },
            {
                path: ':id',
                name: ROUTE_NAME_ITEM.APP_SETTING.EDIT,
                component: AppItemSettingEdit,
                meta: { requiresAuth: true }
            }
        ]
    }
];
